import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const isSingleApprovalLog = (obj) => {
  return obj && typeof obj === 'object' && !Array.isArray(obj)
    && (obj.id != null || obj.logDate != null || obj.approvalLevel != null || obj.userName != null);
};

const normalizeApprovalLogResponse = (response) => {
  if (!response || response.data === undefined) return [];
  const body = response.data;
  if (body == null) return [];
  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body?.result)) return body.result;
  if (isSingleApprovalLog(body)) return [body];
  if (isSingleApprovalLog(body?.data)) return [body.data];
  if (isSingleApprovalLog(body?.result)) return [body.result];
  return [];
};

const fetchPoApprovalFlowLog = async (poId) => {
  if (!poId) return [];
  const response = await axios.get(`${apiurl?.getPoApprovalFlowLog}?purchaseOrderId=${poId}`);
  return normalizeApprovalLogResponse(response);
};

const getPoApprovalFlowLog = (poId) => {
  return useQuery(
    ['getPoApprovalFlowLog', poId],
    () => fetchPoApprovalFlowLog(poId),
    { enabled: !!poId, refetchOnWindowFocus: false }
  );
};

export default getPoApprovalFlowLog;
export { fetchPoApprovalFlowLog };
